
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingCTA from '../components/FloatingCTA';
import { Building, MapPin, Mail, Phone, Globe } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="section-padding bg-primary-brand text-white pt-32">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in-up">Impressum</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed fade-in-up-delay">
            Rechtliche Informationen und Angaben zur AMMING GmbH
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="space-y-12 fade-in-up">
            
            {/* Company Information */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">Angaben zum Unternehmen</h2>
              
              <div className="space-y-4 text-gray-700">
                <div>
                  <h3 className="font-semibold text-primary-brand mb-2">AMMING GmbH</h3>
                  <div className="flex items-start space-x-3">
                    <MapPin className="h-5 w-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p>Max-Planck-Straße 4</p>
                      <p>85609 Aschheim</p>
                    </div>
                  </div>
                </div>
                
                <div className="pt-4">
                  <h4 className="font-medium text-gray-800 mb-2">Handelsregister</h4>
                  <p>HRB 301840</p>
                  <p>Amtsgericht München</p>
                </div>
                
                <div className="pt-4">
                  <h4 className="font-medium text-gray-800 mb-2">Vertreten durch</h4>
                  <p>Alen Mikic, Geschäftsführer (alleinvertretungsberechtigt)</p>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">Kontakt</h2>
              
              <div className="space-y-4 text-gray-700">
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-gray-400" />
                  <span>E-Mail: </span>
                  <a href="mailto:am@amming.de" className="text-primary-brand hover:underline">
                    am@amming.de
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-gray-400" />
                  <span>Telefon: </span>
                  <a href="tel:+4915770305796" className="text-primary-brand hover:underline">
                    +4915770305796
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Globe className="h-5 w-5 text-gray-400" />
                  <span>Website: </span>
                  <a href="https://www.amming.de" className="text-primary-brand hover:underline">
                    www.amming.de
                  </a>
                </div>
                
                <div className="pt-4">
                  <h4 className="font-medium text-gray-800 mb-2">Redaktionell verantwortlich</h4>
                  <p>Alen Mikic</p>
                </div>
              </div>
            </div>

            {/* EU Dispute Resolution */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">EU-Streitschlichtung</h2>
              <div className="space-y-4 text-gray-700">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                </p>
                <p>
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-brand hover:underline">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse findest du oben im Impressum.</p>
              </div>
            </div>

            {/* Consumer Dispute Resolution */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
              <p className="text-gray-700">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            {/* VAT ID */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">Umsatzsteuer-ID</h2>
              <p className="text-gray-700">Umsatzsteuer-ID (§ 27 a UStG): DE454682294</p>
            </div>

            {/* Website Design & Development */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary-brand mb-6">Website Design & Entwicklung</h2>
              <div className="space-y-4 text-gray-700">
                <p>Design und Entwicklung dieser Website wurden realisiert von:</p>
                
                <div className="bg-gray-50 rounded-lg p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <img
                      src="https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/impressum//nz_logo_full.png"
                      alt="neunzigzehn"
                      className="h-12 w-auto"
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <h4 className="font-semibold text-primary-brand">neunzigzehn</h4>
                    <p className="text-sm">
                      Digitale Lösungen für moderne Unternehmen
                    </p>
                    <p className="text-sm">
                      Website: 
                      <a 
                        href="https://neunzigzehn.com/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-primary-brand hover:text-secondary-brand transition-colors ml-2 underline font-medium"
                      >
                        neunzigzehn.com
                      </a>
                    </p>
                  </div>
                </div>
                
                <p className="text-sm text-gray-600">
                  Konzeption, Design und technische Umsetzung dieser Website wurden von neunzigzehn durchgeführt. 
                  Alle Rechte am Design und der technischen Implementierung liegen bei neunzigzehn.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default Impressum;
